export default __webpack_public_path__ + "static/media/trustLoadingDark.8b4b34b3.svg";